"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareCheckList = exports.handleUpdateVideoInput = exports.handleUpdateUserBackground = exports.handleTransformedVideoInput = exports.getWarningMessages = exports.getUserNameFromPresenterTitle = exports.getNotificationStatus = exports.getErrorMessages = exports.getCheckStatus = exports.formatDevicesArrayForDropdown = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _ReadinessCheckerMessaging = require("../../constants/ReadinessCheckerMessaging");
var _constants = require("../../constants");
var _constants2 = require("@studio/constants");
var _chime = require("@studio/chime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Do nothing function to be used as a default callback
var NO_OP = function NO_OP() {};
/**
 * Join component error messages from readinessCheck object
 * @param readinessCheck
 * @returns {*[]}
 */
var getErrorMessages = exports.getErrorMessages = function getErrorMessages(readinessCheck) {
  var errors = [];

  // example is { device: 'FAILED', browser: 'NO_DEVICE_FOUND', microphone: 'FAILED', connectivity: 'FAILED' }
  for (var _i = 0, _Object$entries = Object.entries(readinessCheck); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
      checkType = _Object$entries$_i[0],
      status = _Object$entries$_i[1];
    if (checkType === _constants2.DEVICE_CHECK && [_constants2.FAILED, _constants2.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.USE_DIFFERENT_DEVICE);
    }
    if (checkType === _constants2.BROWSER_CHECK && [_constants2.FAILED, _constants2.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.USE_DIFFERENT_BROWSER);
    }
    if (checkType === _constants2.MICROPHONE_CHECK && [_constants2.FAILED, _constants2.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.NO_MICROPHONE_FOUND);
    }
  }
  return errors;
};

/**
 * Join component warning messages from readinessCheck object
 * @param readinessCheck
 * @returns {*[]}
 */
var getWarningMessages = exports.getWarningMessages = function getWarningMessages(readinessCheck) {
  var warnings = [];
  // example is { device: 'FAILED', browser: 'NO_DEVICE_FOUND', microphone: 'FAILED', connectivity: 'FAILED' }
  for (var _i2 = 0, _Object$entries2 = Object.entries(readinessCheck); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i2], 2),
      checkType = _Object$entries2$_i[0],
      status = _Object$entries2$_i[1];
    if (checkType === _constants2.CAMERA_CHECK && [_constants2.FAILED, _constants2.NO_DEVICE_FOUND, _constants2.PERMISSION_DENIED].includes(status)) {
      warnings.push(_ReadinessCheckerMessaging.NO_CAMERA_FOUND);
    }
    if (checkType === _constants2.CONNECTIVITY_CHECK && [_constants2.FAILED, _constants2.NO_DEVICE_FOUND, _constants2.PERMISSION_DENIED].includes(status)) {
      warnings.push(_ReadinessCheckerMessaging.NETWORK_TRAFFIC_ERROR);
    }
    if (checkType === _constants2.CAMERA_CHECK && status === _constants2.IN_USE) {
      warnings.push(_ReadinessCheckerMessaging.CAMERA_IN_USE_MESSAGE);
    }
    if (checkType === _constants2.MICROPHONE_CHECK && status === _constants2.IN_USE) {
      warnings.push(_ReadinessCheckerMessaging.MICROPHONE_IN_USE_MESSAGE);
    }
  }
  return warnings;
};

/**
 * Get notification status based on readinessCheck object
 * @param readinessCheck
 * @param userRole
 * @param isStandaloneChecker
 * @param shouldJoinWithoutKnock
 * @returns {string}
 */
var getNotificationStatus = exports.getNotificationStatus = function getNotificationStatus(readinessCheck, userRole) {
  var _allOkMessage;
  var isStandaloneChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var shouldJoinWithoutKnock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var errors = getErrorMessages(readinessCheck);
  var warnings = getWarningMessages(readinessCheck);
  var allChecksDone = Object.values(readinessCheck).every(function (value) {
    return value !== _constants2.CHECKING;
  });
  var isAudioPermissionDenied = readinessCheck.microphone === _constants2.PERMISSION_DENIED;
  var isVideoPermissionDenied = readinessCheck.camera === _constants2.PERMISSION_DENIED;
  var isAVPermissionDenied = isAudioPermissionDenied || isVideoPermissionDenied;
  var isVideoAndAudioPermissionDenied = isAudioPermissionDenied && isVideoPermissionDenied;
  var isCameraInUse = readinessCheck.camera === _constants2.IN_USE;
  var isMicrophoneInUse = readinessCheck.microphone === _constants2.IN_USE;
  var hasIssues = (errors.length > 0 || warnings.length > 0) && allChecksDone && !isAVPermissionDenied;
  var allOk = errors.length === 0 && warnings.length === 0 && allChecksDone && !isAVPermissionDenied;
  var isAllOkStandAlone = isStandaloneChecker && allOk;

  // Todo: remove shouldJoinWithoutKnock check when feature flag studio.requirePresenterAuth is removed
  var allOkMessage = (_allOkMessage = {}, (0, _defineProperty2["default"])(_allOkMessage, _constants2.SOURCE_ROLE_HOST, _constants.ALL_OK_HOST), (0, _defineProperty2["default"])(_allOkMessage, _constants2.SOURCE_ROLE_SPEAKER, shouldJoinWithoutKnock ? _constants.ALL_OK_HOST : _constants.ALL_OK_SPEAKER), _allOkMessage);

  // The switch/case is in order of priority of notifications to be shown
  switch (true) {
    case isVideoAndAudioPermissionDenied:
      return _constants.AUDIO_VIDEO_PERMISSION_DENIED;
    case isAudioPermissionDenied:
      return _constants.AUDIO_PERMISSION_DENIED;
    case isVideoPermissionDenied:
      return _constants.VIDEO_PERMISSION_DENIED;
    case isMicrophoneInUse:
      return _constants.MICROPHONE_IN_USE_NOTIFICATION;
    case isCameraInUse:
      return _constants.CAMERA_IN_USE_NOTIFICATION;
    case hasIssues:
      return _constants.READINESS_ISSUES;
    case isAllOkStandAlone:
      return _constants.ALL_OK_STANDALONE;
    case allOk:
      return allOkMessage[userRole];
    default:
      return _constants.NO_NOTIFICATION;
  }
};

/**
 * Formats the devices array to be used in the form dropdown
 * @param devices
 * @returns {*}
 */
var formatDevicesArrayForDropdown = exports.formatDevicesArrayForDropdown = function formatDevicesArrayForDropdown(devices) {
  // Blocked devices
  if (devices.length === 1 && devices[0].label === '') {
    return [{
      label: 'No device found',
      value: ''
    }];
  }

  // No devices at all
  if (devices.length === 0) {
    return [{
      label: 'No device found',
      value: ''
    }];
  }
  return devices.map(function (device) {
    return {
      label: device.label,
      value: device.deviceId,
      group: device.groupId
    };
  });
};

/**
 * Handles transformed video input, formats it and deletes it if not needed
 * @param userBackground
 * @param transformedVideoInput
 * @param setTransformedVideoInput
 * @param clearBackgroundFilter
 * @returns {Promise<*[]>}
 */
var handleTransformedVideoInput = exports.handleTransformedVideoInput = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userBackground, transformedVideoInput, setTransformedVideoInput) {
    var clearBackgroundFilter,
      transformedVideoInputs,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          clearBackgroundFilter = _args.length > 3 && _args[3] !== undefined ? _args[3] : _chime.clearBackgroundFilter;
          transformedVideoInputs = [];
          if (!(userBackground === _constants2.BACKGROUND_OPTIONS.NONE && transformedVideoInput !== null)) {
            _context.next = 15;
            break;
          }
          transformedVideoInputs = [];
          setTransformedVideoInput(null);
          _context.prev = 5;
          _context.next = 8;
          return clearBackgroundFilter(transformedVideoInput);
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](5);
          console.error('Error resetting transformed video input', _context.t0);
        case 13:
          _context.next = 16;
          break;
        case 15:
          transformedVideoInputs = transformedVideoInput === null ? [] : [transformedVideoInput];
        case 16:
          return _context.abrupt("return", transformedVideoInputs);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 10]]);
  }));
  return function handleTransformedVideoInput(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Determines the status of the join page based on the completed checklist and errors
 * @param completedCheckList
 * @param errors
 * @returns {string}
 */
var getCheckStatus = exports.getCheckStatus = function getCheckStatus(completedCheckList, errors) {
  var allChecksDone = Object.values(completedCheckList).every(function (value) {
    return value !== _constants2.CHECKING;
  });
  var isAudioPermissionDenied = completedCheckList.microphone === _constants2.PERMISSION_DENIED;
  if (isAudioPermissionDenied) {
    return _constants.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  }
  if (errors.length > 0) {
    return _constants.JOIN_PAGE_STATUS.ERROR;
  }
  if (allChecksDone && errors.length === 0) {
    return _constants.JOIN_PAGE_STATUS.COMPLETE;
  }
  return _constants.JOIN_PAGE_STATUS.IN_PROGRESS;
};

/**
 * Prepares the checklist for the join component
 * @param readinessCheck
 * @param shouldRequireAudio
 * @returns {*&{microphone: (*|string)}}
 */
var prepareCheckList = exports.prepareCheckList = function prepareCheckList(readinessCheck, shouldRequireAudio) {
  var completedCheckList = _objectSpread(_objectSpread({}, readinessCheck), {}, {
    microphone: shouldRequireAudio ? readinessCheck.microphone : _constants.PASSED
  });
  delete completedCheckList.screenShare;
  delete completedCheckList.speaker;
  return completedCheckList;
};

/**
 * Updates the video input device with appropriate background settings
 * @param {Function} setUserBackgroundLoading - State setter for background loading status
 * @param {string} userBackground - Selected background option (BLUR, NONE, etc.)
 * @param {MediaStream|null} transformedVideoInput - The transformed video stream if any
 * @param {Function} setSelectedVideoInput - State setter for selected video input
 * @param {Function} setTransformedVideoInput - State setter for transformed video input
 * @param {Object|string} videoInputDevice - The video input device to use
 * @param {Function} getVideoInput - Function to retrieve the video input based on the background option
 * @returns {Promise<void>}
 */
var handleUpdateVideoInput = exports.handleUpdateVideoInput = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(setUserBackgroundLoading, userBackground, transformedVideoInput, setSelectedVideoInput, setTransformedVideoInput, videoInputDevice, getVideoInput) {
    var _videoInputDevice$dev, videoInput;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          setUserBackgroundLoading(true);
          _context2.next = 4;
          return getVideoInput(userBackground, transformedVideoInput, (_videoInputDevice$dev = videoInputDevice.device) !== null && _videoInputDevice$dev !== void 0 ? _videoInputDevice$dev : videoInputDevice, NO_OP // No action needed for this callback
          );
        case 4:
          videoInput = _context2.sent;
          setSelectedVideoInput(videoInput);
          if (userBackground !== _constants2.BACKGROUND_OPTIONS.NONE) {
            setTransformedVideoInput(videoInput);
          }
          _context2.next = 12;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          console.error('Error updating user background:', _context2.t0);
        case 12:
          _context2.prev = 12;
          setUserBackgroundLoading(false);
          return _context2.finish(12);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9, 12, 15]]);
  }));
  return function handleUpdateVideoInput(_x4, _x5, _x6, _x7, _x8, _x9, _x10) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Updates the user's background setting and applies it to the video input
 * @param {Function} setUserBackgroundLoading - State setter for background loading status
 * @param {MediaStream|null} transformedVideoInput - The transformed video stream if any
 * @param {Object} selectedVideoInput - The currently selected video input
 * @param {Function} setUserBackground - State setter for user background option
 * @param {Function} setSelectedVideoInput - State setter for selected video input
 * @param {Function} setTransformedVideoInput - State setter for transformed video input
 * @param {string} backgroundOption - The background option to apply (BLUR, NONE, etc.)
 * @param {Function} getVideoInput - Function to retrieve the video input based on the background option
 * @returns {Promise<void>}
 */
var handleUpdateUserBackground = exports.handleUpdateUserBackground = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(setUserBackgroundLoading, transformedVideoInput, selectedVideoInput, setUserBackground, setSelectedVideoInput, setTransformedVideoInput, backgroundOption, getVideoInput) {
    var _selectedVideoInput$d, videoInput;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          setUserBackgroundLoading(true);
          _context3.next = 4;
          return getVideoInput(backgroundOption, transformedVideoInput, (_selectedVideoInput$d = selectedVideoInput.device) !== null && _selectedVideoInput$d !== void 0 ? _selectedVideoInput$d : selectedVideoInput, NO_OP // No action needed for this callback
          );
        case 4:
          videoInput = _context3.sent;
          setUserBackground(backgroundOption);
          setSelectedVideoInput(videoInput);
          if (backgroundOption !== _constants2.BACKGROUND_OPTIONS.NONE) {
            setTransformedVideoInput(videoInput);
          }
          _context3.next = 13;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          console.error('Error updating user background:', _context3.t0);
        case 13:
          _context3.prev = 13;
          setUserBackgroundLoading(false);
          return _context3.finish(13);
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10, 13, 16]]);
  }));
  return function handleUpdateUserBackground(_x11, _x12, _x13, _x14, _x15, _x16, _x17, _x18) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Extracts first and last names from a full presenter title string
 * @param presenterTitle
 * @returns {{firstName: (*|string), lastName: (*|string)}}
 */
var getUserNameFromPresenterTitle = exports.getUserNameFromPresenterTitle = function getUserNameFromPresenterTitle(presenterTitle) {
  var names = presenterTitle.split(' ');
  return {
    firstName: names[0] || '',
    lastName: names.slice(1).join(' ') || ''
  };
};